module.exports = __webpack_public_path__ + "static/media/error400.f43a281a.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/img/error/error400.png
// module id = 698
// module chunks = 8